<template>
  <div class="monitor-selector">
    <label for="monitor-model">Monitor Model</label>
    <md-field>
      <md-select id="monitor-model" :value="value" :disabled="disabled" name="monitor-model" @input="update">
        <md-option
          v-for="monitorModel in availableMonitorModels"
          :key="monitorModel.key"
          :value="monitorModel.key"
        >
          {{ monitorModel.label.en }}
        </md-option>
      </md-select>
    </md-field>
  </div>
</template>

<script>
export default {
  name: 'monitor-selector',
  props: {
    monitorModels: {
      type: Array,
      default: () => [],
    },
    value: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      required: true,
    },
  },
  computed: {
    availableMonitorModels() {
      return this.monitorModels.filter(
        (model) =>
          !model.productTypes ||
          model.productTypes.includes(this.user.productType)
      );
    },
  },
  methods: {
    update(value) {
      this.$emit('input', value);
    },
  },
};
</script>

<style scoped>

</style>
